import {
  CButton,
  CCardHeader,
  CCol,
  CForm,
  CInput,
  CInputGroup,
  CLabel,
  CRow,
} from "@coreui/react";
import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Auth from "src/auth";
import { apiCall } from "src/_apiConfig/apiCall";
import ConfirmationPopup from "../common/ConfirmationPopup";

const OfflinePaymentWithTypeCheque = () => {
  const { authenticated } = Auth();
  const { lotid } = useParams();
  const [selectedFile, setSelectedFile] = useState();
  const [amount, setAmount] = useState();
  const [chequeno, setChequeNo] = useState();
  const [chequedate, setChequeDate] = useState();
  const [bankname, setBankName] = useState();
  const history = useHistory();
  //Confirmation popup------------------------------------
  const [CPopUpId, setCPopUpId] = useState();
  const [CPopUpIndex, setCPopUpIndex] = useState();
  const [CPopUpDisplayConfirmationModal, setCPopUpDisplayConfirmationModal] =
    useState(false);
  const [CPopUpBodyText, setCPopUpBodyText] = useState();
  // adding button loader
  const [ButtonLoader, SetButtonLodaer] = useState(false);
  const handleConfirmationPopUpModalClose = () =>
    setCPopUpDisplayConfirmationModal(false);
  //-------------------------------------------------------
  console.log("LOG-1" + lotid);
  const decrypted = window.atob(lotid);
  console.log("LOG-1" + decrypted);

  const backToListViewHandler = async (e) => {
    history.push(`/lotlistview/${lotid}`, {
      from: window.location.href,
    });
  };

  const ConfirmationPopupHandler = async (
    popupid,
    popupindex,
    popupbodytext
  ) => {
    setCPopUpId(popupid);
    setCPopUpIndex(popupindex);
    setCPopUpDisplayConfirmationModal(true);
    setCPopUpBodyText(popupbodytext);
  };

  const SubmitConfirmationPopUpResponse = async () => {
    SetButtonLodaer(true);
    submitHandler();
  };

  const submitHandler = async (e) => {
    const header = new Headers();
    const data = new FormData();
    data.append("file", selectedFile);
    header.append("Accept", "application/json");
    const response = await apiCall(`Cheque/Upload`, "POST", header, data);
    const jsonobj = await response.json();
    if (response.status === 200) {
      header.append("Content-Type", "application/json");
      let URL = "Cheque/Add";

      // if (type == "transferemd") {
      //   URL = "BG/TransferLotEMD15";
      // } else if (type == "transferemdfee") {
      //   URL = "BG/TransferLotEMDFee";
      // }
      const uploadResponse = await apiCall(
        URL,
        "POST",
        header,
        JSON.stringify({
          chequeno: chequeno,
          chequedate: chequedate,
          amount: Number(amount),
          lotid: Number(decrypted),
          userid: authenticated.userId,
          filePath: jsonobj,
          bankname: bankname,
        })
      );
      const uploadjsonobj = await uploadResponse.json();
      if (
        uploadResponse.status === 200 &&
        uploadjsonobj !== -1 &&
        uploadjsonobj !== -2
      ) {
        history.push(`/lotlistview/${lotid}`, {
          from: window.location.href,
        });
      }
    }
  };

  return (
    <>
      <CCardHeader className="mb-3 shadow-sm">
        <CRow className="pt-3" xl={12}>
          <CCol xl={10}>
            <h3>Cheque Payment</h3>
          </CCol>
        </CRow>
        <hr />
        <CForm className="needs-validation">
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel htmlFor="formFile" className="col-sm-12 col-form-label">
                Upload Cheque :
              </CLabel>
            </CCol>

            <CCol xl={4}>
              <CInputGroup className="mb-3">
                <div className="custom-file">
                  <input
                    id="inputGroupFile01"
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    className="custom-file-input"
                    onChange={(e) => {
                      setSelectedFile(e.target.files[0]);
                    }}
                  />
                  <label
                    className="custom-file-label "
                    htmlFor="inputGroupFile01"
                  >
                    {selectedFile ? selectedFile.name : <>Choose file</>}
                  </label>
                </div>
              </CInputGroup>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom21"
                className="col-sm-12 col-form-label"
              >
                Bank Name:
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                min="1"
                onChange={(e) => {
                  setBankName(e.target.value);
                }}
                id="validationCustom21"
                value={bankname ? bankname : " "}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom21"
                className="col-sm-12 col-form-label"
              >
                Cheque No :
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                min="1"
                onChange={(e) => {
                  setChequeNo(e.target.value);
                }}
                id="validationCustom21"
                value={chequeno ? chequeno : " "}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom20"
                className="col-sm-12 col-form-label"
              >
                Amount :
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                min="1"
                type="number"
                onChange={(e) => {
                  setAmount(e.target.value < 0 ? 0 : e.target.value);
                }}
                id="validationCustom20"
                value={amount ? amount : " "}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CLabel
                htmlFor="validationCustom22"
                className="col-sm-12 col-form-label"
              >
                Cheque Due Date :
              </CLabel>
            </CCol>
            <CCol xl={2}>
              <CInput
                type="date"
                placeholder=""
                onChange={(e) => {
                  setChequeDate(e.target.value);
                }}
                value={chequedate ? chequedate : " "}
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol xl={2}>
              <CButton
                className="ml-3"
                //type="submit"
                //onClick={submitHandler}
                onClick={() =>
                  ConfirmationPopupHandler(
                    1,
                    -1,
                    "Are you sure you want to proceed ?"
                  )
                }
                disabled={
                  selectedFile && amount && bankname && chequeno && chequedate
                    ? false
                    : true
                }
                color="success"
              >
                Submit
              </CButton>
              <CButton
                className="ml-3"
                type="submit"
                onClick={backToListViewHandler}
                color="success"
              >
                Back
              </CButton>
              <div>
                <ConfirmationPopup
                  showModal={CPopUpDisplayConfirmationModal}
                  hideModal={handleConfirmationPopUpModalClose}
                  confirmModal={SubmitConfirmationPopUpResponse}
                  id={CPopUpId}
                  index={CPopUpIndex}
                  ModalBody={CPopUpBodyText}
                  // ModalTitle={CPopUpTitle}
                  confirmButtonCss="btn btn-danger"
                  ButtonLoader={ButtonLoader}
                />
              </div>
            </CCol>
          </CRow>{" "}
        </CForm>
      </CCardHeader>
    </>
  );
};
export default OfflinePaymentWithTypeCheque;
